import { render, staticRenderFns } from "./listaAtendimento.vue?vue&type=template&id=ae5b0976&scoped=true"
import script from "./listaAtendimento.vue?vue&type=script&lang=js"
export * from "./listaAtendimento.vue?vue&type=script&lang=js"
import style0 from "./listaAtendimento.vue?vue&type=style&index=0&id=ae5b0976&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5b0976",
  null
  
)

export default component.exports